module.exports = __webpack_public_path__ + "img/polygon.efb8b898.svg";